export default __webpack_public_path__ + "static/media/logo-white.8f1ef4f3.png";